// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallStar24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M20 11C20.4142 11 20.75 11.3358 20.75 11.75C20.75 12.1642 20.4142 12.5 20 12.5H4C3.58579 12.5 3.25 12.1642 3.25 11.75C3.25 11.3358 3.58579 11 4 11H20Z" />
				<path d="M15.3506 4.4472C15.5577 4.08848 16.0164 3.96557 16.3751 4.17268C16.7338 4.37979 16.8567 4.83848 16.6496 5.1972L8.64962 19.0536C8.44252 19.4123 7.98382 19.5352 7.62511 19.3281C7.26639 19.121 7.14348 18.6623 7.35059 18.3036L15.3506 4.4472Z" />
				<path d="M16.6497 18.3038C16.8568 18.6625 16.7339 19.1212 16.3751 19.3283C16.0164 19.5354 15.5577 19.4125 15.3506 19.0538L7.35062 5.19737C7.14351 4.83865 7.26642 4.37996 7.62514 4.17285C7.98386 3.96574 8.44255 4.08865 8.64966 4.44737L16.6497 18.3038Z" />
			</Svg>
		);
	}
);
SvgCallStar24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallStar24;
